import * as v from "valibot";

export const requestPasswordResetRpcContract = {
  name: "request-password-reset",
  paramsSchema: v.object({
    email: v.pipe(v.string(), v.minLength(1, "Email is required"), v.email("Invalid email format")),
    returnTo: v.optional(v.string()),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    message: v.string(),
  }),
} as const;
